import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function House2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M17.9973 1.73802C16.8442 0.753992 15.1558 0.753992 14.0027 1.73802L2.09128 11.9202C1.39121 12.5106 1 13.3703 1 14.2818V28.0272C1 29.6638 2.32807 31 3.9547 31H28.0453C29.6719 31 31 29.6638 31 28.0272V14.2818C31 13.3703 30.6088 12.5106 29.9087 11.9202L17.9973 1.73802ZM21.8476 28.9284H19.7886V22.2059C19.7886 21.7087 19.3871 21.3047 18.8929 21.3047H13.1071C12.6129 21.3047 12.2114 21.7087 12.2114 22.2059V28.9284H10.1524V22.2059C10.1524 20.5693 11.4804 19.2331 13.1071 19.2331H18.8929C20.5196 19.2331 21.8476 20.5693 21.8476 22.2059V28.9284Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
